/* eslint-disable react/prop-types */
import { FastField, Formik } from 'formik';
import React, { useEffect, useRef } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { addModal, removeModal } from 'Redux/modules/modal/actions';
import ClosePopup from 'Assets/images/close-popup.svg';
import { Button, Form, Grid, Modal } from 'semantic-ui-react';
import { InputField, SingleDatePickerField, PhoneInput } from 'Modules/Formik';
import moment from 'moment';
import { getCountries } from 'Redux/modules/config/actions';
import { createPatient } from 'Redux/modules/patient/actions';

import css from './RegisterPatient.less';
import { schemaValidation } from './Validation';

const initialValues = {
  firstName: '',
  lastName: '',
  phoneCountryCode: '+65',
  phoneNumber: '',
  idNumber: '',
  dateOfBirth: '',
  email: '',
};

const genOptionCountry = list =>
  list.map(({ id, phoneCountryCode, iso }) => ({
    key: id,
    value: phoneCountryCode,
    text: phoneCountryCode,
    flag: iso.toLowerCase(),
  }));

const RegisterPatient = ({ data, id }) => {
  const ref = useRef(null);
  const country = useSelector(state => state.config.country, shallowEqual);
  const { status } = useSelector(state => state.patients, shallowEqual);
  const dispatch = useDispatch();

  const onClose = () => {
    dispatch(removeModal(id));
  };

  const onSubmit = async values => {
    try {
      const rs = await dispatch(
        createPatient({
          ...values,
          dateOfBirth: values.dateOfBirth.format('YYYY-MM-DDTHH:mm:ssZ'),
        }),
      );
      data.onRegistered?.(rs.data);
      onClose();
    } catch (e) {
      dispatch(
        addModal({
          type: 'commonModal',
          id: 6,
          data: {
            title: 'Error',
            content: e.message,
            size: 'tiny',
          },
        }),
      );
    }
  };

  useEffect(() => {
    dispatch(getCountries());
  }, [dispatch]);

  const isCreating = status.createPatient === 0;
  return (
    <div className={css.container}>
      <Modal
        onClose={onClose}
        open
        closeIcon={<img className={css.closeIcon} src={ClosePopup} alt="close popup" />}
        className={css.customModal}
        size="medium">
        <Modal.Header>Register New Patient</Modal.Header>
        <Modal.Content className={css.modalContent}>
          <Formik
            initialValues={initialValues}
            validationSchema={schemaValidation}
            validateOnChange
            innerRef={ref}
            onSubmit={onSubmit}>
            <Form>
              <Grid>
                <Grid.Row columns={2}>
                  <Grid.Column>
                    <FastField
                      name="firstName"
                      component={InputField}
                      placeholder="First Name"
                      label="First Name"
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <FastField
                      name="lastName"
                      component={InputField}
                      placeholder="Last Name"
                      label="Last Name"
                    />
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row columns={2}>
                  <Grid.Column>
                    <FastField
                      name="dateOfBirth"
                      component={SingleDatePickerField}
                      placeholder="Date of Birth"
                      label="DOB"
                      isOutsideRange={day => day.isAfter(moment())}
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <FastField
                      name="idNumber"
                      component={InputField}
                      placeholder="Government ID"
                      label="Government ID *"
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row columns={2}>
                  <Grid.Column>
                    <PhoneInput label="Phone" options={genOptionCountry(country)} />
                  </Grid.Column>
                  <Grid.Column>
                    <FastField
                      name="email"
                      component={InputField}
                      placeholder="Email"
                      label="Email"
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Form>
          </Formik>
        </Modal.Content>
        <Modal.Actions>
          <Button
            onClick={() => {
              onClose();
            }}>
            Cancel
          </Button>
          <Button
            onClick={() => {
              ref?.current?.handleSubmit();
            }}
            primary
            className={css.submitBtn}
            loading={isCreating}
            disabled={isCreating}>
            Save
          </Button>
        </Modal.Actions>
      </Modal>
    </div>
  );
};

export default RegisterPatient;
